import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { MANAGED_MAILBOX_ERROR_CODES } from "@amtana/managed-mailbox-contract";

// What a user reads when buying or managing mailboxes fails (packages/module ADR-001),
// in English and Spanish.

const EN = {
  planRequiredTitle: "Managed mailboxes need a paid plan",
  planRequiredDescription: "They're available on every paid plan.",
  domainLimitTitle: "Domain limit reached",
  domainLimitDescription: "Your plan has no room for more domains. Upgrade to add more.",
  domainUnavailableTitle: "One of the domains is no longer available",
  domainUnavailableDescription: "Pick another one and try again.",
  orderNotFoundTitle: "This order doesn't exist",
  orderNotFoundDescription: "Open your domains to see the orders you placed.",
  domainNotFoundTitle: "This domain doesn't exist",
  domainNotFoundDescription: "It may have been deleted. Open your domains to pick another.",
  mailboxNotFoundTitle: "This mailbox doesn't exist",
  mailboxNotFoundDescription: "It may have been deleted. Open your mailboxes to pick another.",
} as const;

const ES: Translation<typeof EN> = {
  planRequiredTitle: "Los buzones gestionados necesitan un plan de pago",
  planRequiredDescription: "Están disponibles en todos los planes de pago.",
  domainLimitTitle: "Límite de dominios alcanzado",
  domainLimitDescription: "Tu plan no tiene espacio para más dominios. Mejora tu plan para añadir más.",
  domainUnavailableTitle: "Uno de los dominios ya no está disponible",
  domainUnavailableDescription: "Elige otro e inténtalo de nuevo.",
  orderNotFoundTitle: "Este pedido no existe",
  orderNotFoundDescription: "Abre tus dominios para ver los pedidos que hiciste.",
  domainNotFoundTitle: "Este dominio no existe",
  domainNotFoundDescription: "Puede que se haya eliminado. Abre tus dominios para elegir otro.",
  mailboxNotFoundTitle: "Este buzón no existe",
  mailboxNotFoundDescription: "Puede que se haya eliminado. Abre tus buzones para elegir otro.",
};

export const MANAGED_MAILBOX_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const MANAGED_MAILBOX_ERROR_COPY = {
  managed_mailbox_plan_required: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "planRequiredTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "planRequiredDescription"),
  },
  managed_mailbox_domain_limit_reached: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainLimitTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainLimitDescription"),
  },
  managed_mailbox_domain_unavailable: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainUnavailableTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainUnavailableDescription"),
  },
  managed_mailbox_order_not_found: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "orderNotFoundTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "orderNotFoundDescription"),
  },
  managed_mailbox_domain_not_found: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainNotFoundTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "domainNotFoundDescription"),
  },
  managed_mailbox_mailbox_not_found: {
    title: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "mailboxNotFoundTitle"),
    description: phrase(MANAGED_MAILBOX_ERROR_CATALOGS, "mailboxNotFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof MANAGED_MAILBOX_ERROR_CODES>;
